// import TicketMenuManagementCreate from "./lib/create";
import TicketsTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import PageTitle from 'components/pageTitle';

import * as S from './styles';
// import TicketCounts from './lib/ticketCounts';

export default function TicketsPage() {
  const { tickets } = useTypedSelector((state) => state.Tickets);

  return (
    <S.Container>
      <PageTitle title="Ticket System" />
      {/* <TicketCounts data={ticketStatistics.data} /> */}

      <TicketsTable data={tickets?.data?.data || []} loading={tickets?.loading} infiniteScroll={true} />

      {/* <AppLoading loading={departments.loading || ticketCategory.loading || ticketStatistics.loading} /> */}
    </S.Container>
  );
}
